import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal, FormControl, FormGroup } from 'react-bootstrap';
import { withTranslation, Translation } from 'react-i18next';
class TariffConfirmationButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirmationModal: false,
        };
        this.storeChange = () => this.handleStoreChange();
    }
    componentDidMount() {
        this.props.store.addChangeListener(this.storeChange);
    }
    componentWillUnmount() {
        this.props.store.removeChangeListener(this.storeChange);
    }
    handleStoreChange() {
        if (this.props.store.getStatus() === 'success') {
            this.setState({ showConfirmationModal: false });
        }
    }
    render() {
        const { controlTitle, disabled, skipConfirmation, confirmationTitle, message, confirmTitle, dismissTitle, store, } = this.props;
        let control = (React.createElement(Button, { bsStyle: "primary", disabled: disabled }, controlTitle));
        if (this.props.controlType === 'icon') {
            control = controlTitle;
        }
        return (React.createElement("span", { onClick: skipConfirmation ? this.handleConfirm() : this.openModal() },
            control,
            React.createElement("span", null,
                React.createElement(TariffConfirmationModal, { message: message, show: this.state.showConfirmationModal, onHide: () => this.setState({ showConfirmationModal: false }), confirmationTitle: confirmationTitle, confirmTitle: confirmTitle, dismissTitle: dismissTitle, onConfirm: this.handleConfirm(), store: store }))));
    }
    handleConfirm() {
        return (password) => {
            this.props.onConfirm(password);
        };
    }
    openModal() {
        return () => {
            this.setState({
                showConfirmationModal: !this.state.showConfirmationModal,
            });
        };
    }
}
TariffConfirmationButton.propTypes = {
    controlTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    confirmationTitle: PropTypes.string,
    message: PropTypes.string.isRequired,
    confirmTitle: PropTypes.string.isRequired,
    dismissTitle: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    skipConfirmation: PropTypes.bool,
    controlType: PropTypes.string.isRequired,
    store: PropTypes.object.isRequired,
};
class TariffConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = (e) => {
            this.props.onConfirm(this.state.password);
        };
        this.state = {
            password: '',
        };
    }
    render() {
        const confirmTitle = this.props.confirmTitle;
        const dismissTitle = this.props.dismissTitle;
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onHide() },
            React.createElement(Modal.Header, null,
                React.createElement(Translation, null, (t) => React.createElement("h1", null, t('CONFIRM_UPDATE')))),
            React.createElement(Modal.Body, null,
                React.createElement(Translation, null, (t) => (React.createElement(React.Fragment, null,
                    React.createElement("p", null, t('CHANGES_TO_TARIFF_MSG')),
                    React.createElement("p", null, t('PRICING_UPDATES_NIGHTLY_MSG')))))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.onCancel() }, dismissTitle),
                React.createElement(Button, { bsStyle: "primary", onClick: this.onSubmit }, confirmTitle))));
    }
    onCancel() {
        return (e) => {
            e.preventDefault();
            this.props.store.reset();
            this.props.onHide();
        };
    }
}
export default withTranslation()(TariffConfirmationButton);
